"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _LineString = _interopRequireDefault(require("../LineString"));

var _Point = _interopRequireDefault(require("../Point"));

var _Polygon = _interopRequireDefault(require("../Polygon"));

var _MultiPoint = _interopRequireDefault(require("../MultiPoint"));

var _LinearRing = _interopRequireDefault(require("../LinearRing"));

var _MultiPolygon = _interopRequireDefault(require("../MultiPolygon"));

var _GeometryCollection = _interopRequireDefault(require("../GeometryCollection"));

var _ArrayList = _interopRequireDefault(require("../../../../../java/util/ArrayList"));

var _Assert = _interopRequireDefault(require("../../util/Assert"));

var _MultiLineString = _interopRequireDefault(require("../MultiLineString"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

var GeometryEditor =
/*#__PURE__*/
function () {
  function GeometryEditor() {
    _classCallCheck(this, GeometryEditor);

    GeometryEditor.constructor_.apply(this, arguments);
  }

  _createClass(GeometryEditor, [{
    key: "setCopyUserData",
    value: function setCopyUserData(isUserDataCopied) {
      this._isUserDataCopied = isUserDataCopied;
    }
  }, {
    key: "edit",
    value: function edit(geometry, operation) {
      if (geometry === null) return null;
      var result = this.editInternal(geometry, operation);

      if (this._isUserDataCopied) {
        result.setUserData(geometry.getUserData());
      }

      return result;
    }
  }, {
    key: "editInternal",
    value: function editInternal(geometry, operation) {
      if (this._factory === null) this._factory = geometry.getFactory();

      if (geometry instanceof _GeometryCollection.default) {
        return this.editGeometryCollection(geometry, operation);
      }

      if (geometry instanceof _Polygon.default) {
        return this.editPolygon(geometry, operation);
      }

      if (geometry instanceof _Point.default) {
        return operation.edit(geometry, this._factory);
      }

      if (geometry instanceof _LineString.default) {
        return operation.edit(geometry, this._factory);
      }

      _Assert.default.shouldNeverReachHere("Unsupported Geometry class: " + geometry.getClass().getName());

      return null;
    }
  }, {
    key: "editGeometryCollection",
    value: function editGeometryCollection(collection, operation) {
      var collectionForType = operation.edit(collection, this._factory);
      var geometries = new _ArrayList.default();

      for (var i = 0; i < collectionForType.getNumGeometries(); i++) {
        var geometry = this.edit(collectionForType.getGeometryN(i), operation);

        if (geometry === null || geometry.isEmpty()) {
          continue;
        }

        geometries.add(geometry);
      }

      if (collectionForType.getClass() === _MultiPoint.default) {
        return this._factory.createMultiPoint(geometries.toArray([]));
      }

      if (collectionForType.getClass() === _MultiLineString.default) {
        return this._factory.createMultiLineString(geometries.toArray([]));
      }

      if (collectionForType.getClass() === _MultiPolygon.default) {
        return this._factory.createMultiPolygon(geometries.toArray([]));
      }

      return this._factory.createGeometryCollection(geometries.toArray([]));
    }
  }, {
    key: "editPolygon",
    value: function editPolygon(polygon, operation) {
      var newPolygon = operation.edit(polygon, this._factory);
      if (newPolygon === null) newPolygon = this._factory.createPolygon();

      if (newPolygon.isEmpty()) {
        return newPolygon;
      }

      var shell = this.edit(newPolygon.getExteriorRing(), operation);

      if (shell === null || shell.isEmpty()) {
        return this._factory.createPolygon();
      }

      var holes = new _ArrayList.default();

      for (var i = 0; i < newPolygon.getNumInteriorRing(); i++) {
        var hole = this.edit(newPolygon.getInteriorRingN(i), operation);

        if (hole === null || hole.isEmpty()) {
          continue;
        }

        holes.add(hole);
      }

      return this._factory.createPolygon(shell, holes.toArray([]));
    }
  }, {
    key: "getClass",
    value: function getClass() {
      return GeometryEditor;
    }
  }, {
    key: "interfaces_",
    get: function get() {
      return [];
    }
  }]);

  return GeometryEditor;
}();

exports.default = GeometryEditor;

function GeometryEditorOperation() {}

GeometryEditor.GeometryEditorOperation = GeometryEditorOperation;

var NoOpGeometryOperation =
/*#__PURE__*/
function () {
  function NoOpGeometryOperation() {
    _classCallCheck(this, NoOpGeometryOperation);

    NoOpGeometryOperation.constructor_.apply(this, arguments);
  }

  _createClass(NoOpGeometryOperation, [{
    key: "edit",
    value: function edit(geometry, factory) {
      return geometry;
    }
  }, {
    key: "getClass",
    value: function getClass() {
      return NoOpGeometryOperation;
    }
  }, {
    key: "interfaces_",
    get: function get() {
      return [GeometryEditorOperation];
    }
  }]);

  return NoOpGeometryOperation;
}();

NoOpGeometryOperation.constructor_ = function () {};

var CoordinateOperation =
/*#__PURE__*/
function () {
  function CoordinateOperation() {
    _classCallCheck(this, CoordinateOperation);

    CoordinateOperation.constructor_.apply(this, arguments);
  }

  _createClass(CoordinateOperation, [{
    key: "edit",
    value: function edit(geometry, factory) {
      var coordinates = this.edit(geometry.getCoordinates(), geometry);

      if (geometry instanceof _LinearRing.default) {
        if (coordinates === null) return factory.createLinearRing();else return factory.createLinearRing(coordinates);
      }

      if (geometry instanceof _LineString.default) {
        if (coordinates === null) return factory.createLineString();else return factory.createLineString(coordinates);
      }

      if (geometry instanceof _Point.default) {
        if (coordinates === null || coordinates.length === 0) return factory.createPoint();else return factory.createPoint(coordinates[0]);
      }

      return geometry;
    }
  }, {
    key: "getClass",
    value: function getClass() {
      return CoordinateOperation;
    }
  }, {
    key: "interfaces_",
    get: function get() {
      return [GeometryEditorOperation];
    }
  }]);

  return CoordinateOperation;
}();

CoordinateOperation.constructor_ = function () {};

var CoordinateSequenceOperation =
/*#__PURE__*/
function () {
  function CoordinateSequenceOperation() {
    _classCallCheck(this, CoordinateSequenceOperation);

    CoordinateSequenceOperation.constructor_.apply(this, arguments);
  }

  _createClass(CoordinateSequenceOperation, [{
    key: "edit",
    value: function edit(geometry, factory) {
      if (geometry instanceof _LinearRing.default) {
        return factory.createLinearRing(this.edit(geometry.getCoordinateSequence(), geometry));
      }

      if (geometry instanceof _LineString.default) {
        return factory.createLineString(this.edit(geometry.getCoordinateSequence(), geometry));
      }

      if (geometry instanceof _Point.default) {
        return factory.createPoint(this.edit(geometry.getCoordinateSequence(), geometry));
      }

      return geometry;
    }
  }, {
    key: "getClass",
    value: function getClass() {
      return CoordinateSequenceOperation;
    }
  }, {
    key: "interfaces_",
    get: function get() {
      return [GeometryEditorOperation];
    }
  }]);

  return CoordinateSequenceOperation;
}();

CoordinateSequenceOperation.constructor_ = function () {};

GeometryEditor.NoOpGeometryOperation = NoOpGeometryOperation;
GeometryEditor.CoordinateOperation = CoordinateOperation;
GeometryEditor.CoordinateSequenceOperation = CoordinateSequenceOperation;

GeometryEditor.constructor_ = function () {
  this._factory = null;
  this._isUserDataCopied = false;

  if (arguments.length === 0) {} else if (arguments.length === 1) {
    var factory = arguments[0];
    this._factory = factory;
  }
};